import { ClientConfigType } from 'client/context/ClientConfigContext';
import { datadogRum } from '@datadog/browser-rum';

export const DATADOG_SERVICE_NAME = 'worker-adhoc-shifts';
export const ALLOWED_TRACING_ORIGINS: RegExp[] = [
    /https?:\/\/(.*)?.indeed.com/,
    /https?:\/\/(.*)?.indeed.net/,
    /http:\/\/localhost.*$/,
    /http:\/\/127.0.0.1.*$/,
];

const initDatadogRum = (config: ClientConfigType): void => {
    if (
        typeof config['worker-adhoc-shifts.datadog.applicationId'] !== 'undefined' &&
        typeof config['worker-adhoc-shifts.datadog.clientToken'] !== 'undefined'
    ) {
        datadogRum.init({
            applicationId: config['worker-adhoc-shifts.datadog.applicationId'],
            clientToken: config['worker-adhoc-shifts.datadog.clientToken'],
            site: 'datadoghq.com',
            service: DATADOG_SERVICE_NAME,
            env: config.level,
            version: config.release,
            sampleRate: 100,
            allowedTracingOrigins: ALLOWED_TRACING_ORIGINS,
        });
        datadogRum.addRumGlobalContext('team', 'taco');
    }
};

export default initDatadogRum;
